import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConnectIcon from "../../assets/image/chat with astrologer.png";
import Dashakoot from "../../assets/image/Dashakoot.png";
import Western from "../../assets/image/western.png";
import nakshatra from "../../assets/image/nakshatra.png";
import "./matching.css";

const features = [
  { icon: Dashakoot, label: "Dashakoot", route: "/Dashakoot" },
  { icon: nakshatra, label: "Nakshatra", route: "/Nakshatra" },
  { icon: Western, label: "Western", route: "/Western" },
  {
    icon: ConnectIcon,
    label: "Connect with Astrologer",
    route: "/AstrologerSection",
  },
];

function Ashtakoot() {
  const navigate = useNavigate();

  const [female, setFemale] = useState({
    name: "",
    dateofbirth: "",
    timeofbirth: "",
    city: "",
    latitude: "19.0760", // default Mumbai
    longitude: "72.8777",
  });

  const [male, setMale] = useState({
    name: "",
    dateofbirth: "",
    timeofbirth: "",
    city: "",
    latitude: "28.6139", // default Delhi
    longitude: "77.2090",
  });

  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Fetch coordinates automatically based on city
  const fetchCoordinates = async (city, person) => {
    if (!city) return;
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(city)}`
      );
      const data = await res.json();
      if (data && data[0]) {
        const { lat, lon } = data[0];
        if (person === "female") {
          setFemale((prev) => ({ ...prev, latitude: lat, longitude: lon }));
        } else {
          setMale((prev) => ({ ...prev, latitude: lat, longitude: lon }));
        }
      }
    } catch (err) {
      console.error("Failed to fetch coordinates:", err);
    }
  };

  const handleInputChange = (e, person) => {
    const { name, value } = e.target;
    if (person === "female") {
      setFemale({ ...female, [name]: value });
      if (name === "city") fetchCoordinates(value, "female");
    } else {
      setMale({ ...male, [name]: value });
      if (name === "city") fetchCoordinates(value, "male");
    }
  };

  const book = () => {
    setError("");
    setResult(null);

    const requiredFields = ["name", "dateofbirth", "timeofbirth", "city"];
    for (let field of requiredFields) {
      if (!female[field]) {
        setError(`Please fill female's ${field}`);
        return;
      }
      if (!male[field]) {
        setError(`Please fill male's ${field}`);
        return;
      }
    }

    setLoading(true);

    const [femaleYear, femaleMonth, femaleDate] = female.dateofbirth.split("-");
    const [maleYear, maleMonth, maleDate] = male.dateofbirth.split("-");
    const [femaleHours, femaleMinutes] = female.timeofbirth.split(":");
    const [maleHours, maleMinutes] = male.timeofbirth.split(":");

    fetch(
      `https://api.jyotishamastroapi.com/api/matching/ashtakoot-astro?boy_dob=${maleYear}-${maleMonth}-${maleDate}&boy_tob=${maleHours}:${maleMinutes}&boy_lat=${male.latitude}&boy_lon=${male.longitude}&boy_tz=5.5&girl_dob=${femaleYear}-${femaleMonth}-${femaleDate}&girl_tob=${femaleHours}:${femaleMinutes}&girl_lat=${female.latitude}&girl_lon=${female.longitude}&girl_tz=5.5&lang=en`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",
        },
      }
    )
      .then((response) => {
        if (!response.ok) throw new Error(`API error: ${response.status}`);
        return response.json();
      })
      .then((data) => setResult(data.response || data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  const kootas = [
    "varna",
    "vasya",
    "tara",
    "yoni",
    "grahamaitri",
    "gana",
    "bhakoot",
    "nadi",
  ];

  const renderInputs = (personData, person) => {
    const fields = [
      { name: "name", label: "Full Name", type: "text" },
      { name: "dateofbirth", label: "Date of Birth", type: "date" },
      { name: "timeofbirth", label: "Time of Birth", type: "time" },
      { name: "city", label: "City / Place", type: "text" },
    ];

    return fields.map((field) => (
      <div className="matching-form-group" key={field.name}>
        <label>{field.label}</label>
        <input
          type={field.type}
          name={field.name}
          value={personData[field.name]}
          onChange={(e) => handleInputChange(e, person)}
          required
        />
      </div>
    ));
  };

  return (
    <div className="container">
      <div className="ra-main-matchmaking">
        <div className="row">
          <div className="col-md-9">
            <div className="ra-main-Ashtakoot">
              <h2>Ashtakoot Matching</h2>

              <div className="ra-main-form-section">
                <div className="form-section">
                  <h3>Female Details 👩</h3>
                  <div className="form-grid">{renderInputs(female, "female")}</div>
                </div>

                <div className="form-section">
                  <h3>Male Details 👨‍🦱</h3>
                  <div className="form-grid">{renderInputs(male, "male")}</div>
                </div>
              </div>

              <button className="match-btn" onClick={book} disabled={loading}>
                {loading ? "Matching..." : "Match"}
              </button>

              {error && <div className="error-msg">⚠️ {error}</div>}
              {loading && !error && <div className="loading-msg">Loading...</div>}

              {result && (
                <div className="result-section">
                  <h3>Match Result</h3>
                  <div
                    className="name-box"
                    style={{ textAlign: "center", marginBottom: "15px" }}
                  >
                    <p
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        textAlign: "center",
                        marginBottom: "15px",
                      }}
                    >
                      {female.name} & {male.name}
                    </p>
                  </div>

                  <div className="score-box">
                    <p>
                      <strong>Total Score:</strong> {result.score} / 36
                    </p>
                    {result.bot_response && (
                      <p className="bot-response">💡 {result.bot_response}</p>
                    )}
                  </div>

                  <div className="koota-grid">
                    {kootas.map((koota) => {
                      const item = result[koota];
                      if (!item) return null;

                      return (
                        <div key={koota} className="koota-card">
                          <h4>
                            {item.name} ({item[koota]} / {item.full_score})
                          </h4>
                          <p>
                            <strong>Boy:</strong>{" "}
                            {item[`boy_${koota}`] || item.boy_rasi_name || item.boy_lord || "-"}
                          </p>
                          <p>
                            <strong>Girl:</strong>{" "}
                            {item[`girl_${koota}`] || item.girl_rasi_name || item.girl_lord || "-"}
                          </p>
                          {item.description && (
                            <p className="description">{item.description}</p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-md-3">
            <div className="ra-Ashtakoot-part2">
              <div className="feature-col">
                {features.map((item, index) => (
                  <div
                    className="feature-card"
                    key={index}
                    onClick={() => navigate(item.route)}
                  >
                    <div className="ra-Ashtakoot-part2-main-box">
                      <div className="ra-Ashtakoot-part2-feature-box">
                        <div
                          className="ra-Ashtakoot-part2-feature-icon"
                          style={{ backgroundColor: item.color }}
                        >
                          <img src={item.icon} alt={item.label} />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ashtakoot;
